<div class="dictionary-container">

    <!-- O que o dicionario faz, em uma linha, para quem abre a tela pela
         primeira vez. Sem isso o cadastro parece burocracia. -->
    <nz-alert nzType="info" nzShowIcon
        [nzMessage]="'agentBuilder.dictionary.what'|translateTA"
        [nzDescription]="'agentBuilder.dictionary.whatHint'|translateTA">
    </nz-alert>

    <div class="dictionary-toolbar">

        <button nz-button nzType="primary" (click)="novoTermo()">
            <nz-icon nzType="plus"></nz-icon>
            {{'agentBuilder.dictionary.add'|translateTA}}
        </button>

        <button nz-button nzType="default" (click)="abrirImportacao()">
            <nz-icon nzType="import"></nz-icon>
            {{'agentBuilder.dictionary.import'|translateTA}}
        </button>

        <nz-select [(ngModel)]="filtroDeEscopo" class="dictionary-scope">
            <nz-option nzValue="todos" [nzLabel]="'agentBuilder.dictionary.scope.all'|translateTA"></nz-option>
            <nz-option nzValue="global" [nzLabel]="'agentBuilder.dictionary.scope.global'|translateTA"></nz-option>
            <nz-option [nzValue]="agent?.agentName" [nzLabel]="agent?.agentName"></nz-option>
        </nz-select>

        <input nz-input class="dictionary-search"
            [(ngModel)]="filtroDeTexto"
            [placeholder]="'agentBuilder.dictionary.searchPlaceholder'|translateTA">

    </div>

    <!-- Um termo sem sinonimo nunca casa com a pergunta do usuario, entao ele
         nao faz nada no Java. Vale avisar em vez de deixar o usuario descobrir
         depois que ligou tudo e nada mudou. -->
    @if (quantidadeSemSinonimo > 0) {
        <nz-alert nzType="warning" nzShowIcon class="dictionary-warning"
            [nzMessage]="'agentBuilder.dictionary.missingSynonyms'|translateTA">
        </nz-alert>
    }

    <nz-table
        nzBordered
        [nzLoading]="carregando"
        [nzData]="termosFiltrados"
        [nzNoResult]="semTermosTpl"
        [nzPageSize]="10"
        #tabelaDic
        class="full-table">

        <thead>
            <tr>
                <th nzWidth="180px">{{'agentBuilder.dictionary.term'|translateTA}}</th>
                <th>{{'agentBuilder.dictionary.synonyms'|translateTA}}</th>
                <th nzWidth="150px">{{'agentBuilder.dictionary.technicalId'|translateTA}}</th>
                <th nzWidth="120px">{{'agentBuilder.dictionary.scope'|translateTA}}</th>
                <th nzWidth="90px">{{'agentBuilder.dictionary.active'|translateTA}}</th>
                <th nzWidth="110px">{{'agentBuilder.dictionary.actions'|translateTA}}</th>
            </tr>
        </thead>

        <tbody>
            @for (termo of tabelaDic.data; track termo._id) {
                <tr>
                    <td>
                        <strong>{{termo.termoCanonico}}</strong>
                        @if (termo.definicao) {
                            <div class="dictionary-definition">{{termo.definicao}}</div>
                        }
                    </td>
                    <td>
                        @if (termo.sinonimos?.length > 0) {
                            @for (sinonimo of termo.sinonimos; track sinonimo) {
                                <nz-tag>{{sinonimo}}</nz-tag>
                            }
                        } @else {
                            <nz-tag nzColor="warning">{{'agentBuilder.dictionary.noSynonym'|translateTA}}</nz-tag>
                        }
                    </td>
                    <td>
                        @if (termo.identificadorTecnico) {
                            <code>{{termo.identificadorTecnico}}</code>
                        }
                    </td>
                    <td>
                        @if (termo.escopo === 'global') {
                            {{'agentBuilder.dictionary.scope.global'|translateTA}}
                        } @else {
                            {{termo.escopo}}
                        }
                    </td>
                    <td>
                        @if (termo.ativo !== false) {
                            <nz-tag nzColor="green">{{'agentBuilder.dictionary.yes'|translateTA}}</nz-tag>
                        } @else {
                            <nz-tag>{{'agentBuilder.dictionary.no'|translateTA}}</nz-tag>
                        }
                    </td>
                    <td>
                        <button nz-button nzType="text" nzSize="small"
                            nz-tooltip [nzTooltipTitle]="'agentBuilder.dictionary.edit'|translateTA"
                            (click)="editarTermo(termo)">
                            <nz-icon nzType="edit"></nz-icon>
                        </button>
                        <button nz-button nzType="text" nzSize="small" nzDanger
                            nz-tooltip [nzTooltipTitle]="'agentBuilder.dictionary.remove'|translateTA"
                            (click)="confirmarRemocao(termo)">
                            <nz-icon nzType="delete"></nz-icon>
                        </button>
                    </td>
                </tr>
            }
        </tbody>
    </nz-table>

</div>

<ng-template #semTermosTpl>
    <nz-empty [nzNotFoundContent]="'agentBuilder.dictionary.empty'|translateTA"></nz-empty>
</ng-template>


<!-- ============================================================
     Modal de edicao do termo
     ============================================================ -->
<!-- nzBodyStyle: sem limite de altura o formulario passa do rodape da tela e
     fica sem como rolar, porque o modal cresce junto com o conteudo -->
<nz-modal
    [(nzVisible)]="modalAberto"
    [nzTitle]="'agentBuilder.dictionary.termTitle'|translateTA"
    [nzWidth]="620"
    [nzOkLoading]="salvando"
    [nzBodyStyle]="{ 'max-height': 'calc(100vh - 220px)', 'overflow-y': 'auto' }"
    (nzOnCancel)="fecharModal()"
    (nzOnOk)="salvar()">

    <ng-container *nzModalContent>
        <form nz-form [formGroup]="formulario" nzLayout="vertical">

            <nz-form-item>
                <nz-form-label nzRequired>{{'agentBuilder.dictionary.term'|translateTA}}</nz-form-label>
                <nz-form-control [nzErrorTip]="'agentBuilder.dictionary.termRequired'|translateTA"
                                 [nzExtra]="'agentBuilder.dictionary.term.hint'|translateTA">
                    <input nz-input formControlName="termoCanonico">
                </nz-form-control>
            </nz-form-item>

            <!-- O campo que decide se o dicionario funciona. Fica em destaque,
                 antes dos opcionais. -->
            <nz-form-item>
                <nz-form-label>{{'agentBuilder.dictionary.synonyms'|translateTA}}</nz-form-label>
                <nz-form-control [nzExtra]="'agentBuilder.dictionary.synonyms.hint'|translateTA">

                    <div class="dictionary-synonyms">
                        @for (sinonimo of sinonimos; track sinonimo; let i = $index) {
                            <nz-tag nzMode="closeable" (nzOnClose)="removerSinonimo(i)">{{sinonimo}}</nz-tag>
                        }
                    </div>

                    <nz-space-compact class="dictionary-synonym-input">
                        <input nz-input
                            [(ngModel)]="novoSinonimo"
                            [ngModelOptions]="{standalone: true}"
                            (keydown.enter)="adicionarSinonimo(); $event.preventDefault()"
                            [placeholder]="'agentBuilder.dictionary.synonymPlaceholder'|translateTA">
                        <button nz-button nzType="default" (click)="adicionarSinonimo()">
                            <nz-icon nzType="plus"></nz-icon>
                        </button>
                    </nz-space-compact>

                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label>{{'agentBuilder.dictionary.definition'|translateTA}}</nz-form-label>
                <nz-form-control [nzExtra]="'agentBuilder.dictionary.definition.hint'|translateTA">
                    <textarea nz-input rows="2" formControlName="definicao"></textarea>
                </nz-form-control>
            </nz-form-item>

            <nz-row [nzGutter]="16">
                <nz-col nzSpan="12">
                    <nz-form-item>
                        <nz-form-label>{{'agentBuilder.dictionary.technicalId'|translateTA}}</nz-form-label>
                        <nz-form-control [nzExtra]="'agentBuilder.dictionary.technicalId.hint'|translateTA">
                            <input nz-input formControlName="identificadorTecnico">
                        </nz-form-control>
                    </nz-form-item>
                </nz-col>

                <nz-col nzSpan="12">
                    <nz-form-item>
                        <nz-form-label>{{'agentBuilder.dictionary.scope'|translateTA}}</nz-form-label>
                        <nz-form-control [nzExtra]="'agentBuilder.dictionary.scope.hint'|translateTA">
                            <nz-select formControlName="escopo" class="full-width">
                                <!-- global vale para todos os agentes: so administrador -->
                                @if (podeCriarGlobal) {
                                    <nz-option nzValue="global" [nzLabel]="'agentBuilder.dictionary.scope.global'|translateTA"></nz-option>
                                }
                                <nz-option [nzValue]="agent?.agentName" [nzLabel]="agent?.agentName"></nz-option>
                            </nz-select>
                        </nz-form-control>
                    </nz-form-item>
                </nz-col>
            </nz-row>

            <nz-form-item>
                <nz-form-control>
                    <label nz-checkbox formControlName="ativo">
                        {{'agentBuilder.dictionary.active'|translateTA}}
                    </label>
                </nz-form-control>
            </nz-form-item>

        </form>
    </ng-container>
</nz-modal>


<!-- ============================================================
     Modal de importacao por arquivo
     ============================================================ -->
<nz-modal
    [(nzVisible)]="modalDeImportacaoAberto"
    [nzTitle]="'agentBuilder.dictionary.importTitle'|translateTA"
    [nzWidth]="680"
    [nzOkLoading]="importando"
    [nzOkDisabled]="termosParaImportar.length === 0"
    [nzOkText]="'agentBuilder.dictionary.importConfirm'|translateTA"
    [nzBodyStyle]="{ 'max-height': 'calc(100vh - 220px)', 'overflow-y': 'auto' }"
    (nzOnCancel)="fecharImportacao()"
    (nzOnOk)="confirmarImportacao()">

    <ng-container *nzModalContent>

        <p class="dictionary-import-hint">{{'agentBuilder.dictionary.importHint'|translateTA}}</p>

        @if (!podeCriarGlobal) {
            <nz-alert nzType="info" nzShowIcon class="dictionary-import-aviso"
                [nzMessage]="'agentBuilder.dictionary.scopeRestricted'|translateTA">
            </nz-alert>
        }

        <div class="dictionary-import-acoes">

            <button nz-button nzType="default" (click)="baixarModelo()">
                <nz-icon nzType="download"></nz-icon>
                {{'agentBuilder.dictionary.template'|translateTA}}
            </button>

            <label class="dictionary-arquivo">
                <input type="file" accept=".csv,text/csv" (change)="arquivoEscolhido($event)" hidden>
                <span nz-button nzType="primary">
                    <nz-icon nzType="upload"></nz-icon>
                    {{'agentBuilder.dictionary.chooseFile'|translateTA}}
                </span>
            </label>

            @if (nomeDoArquivo) {
                <span class="dictionary-arquivo-nome">{{nomeDoArquivo}}</span>
            }

        </div>

        @if (erroDoArquivo) {
            <nz-alert nzType="error" nzShowIcon [nzMessage]="erroDoArquivo"></nz-alert>
        }

        @if (termosParaImportar.length > 0) {
            <h4 class="dictionary-import-title">
                {{'agentBuilder.dictionary.importWillCreate'|translateTA}} ({{termosParaImportar.length}})
            </h4>
            <ul class="dictionary-import-list">
                @for (termo of termosParaImportar; track termo.termoCanonico) {
                    <li>
                        <strong>{{termo.termoCanonico}}</strong>
                        @if (termo.identificadorTecnico) {
                            <code>{{termo.identificadorTecnico}}</code>
                        }
                        @if (termo.sinonimos?.length > 0) {
                            <span class="dictionary-import-sin">{{termo.sinonimos.length}} {{'agentBuilder.dictionary.synonymsCount'|translateTA}}</span>
                        } @else {
                            <nz-tag nzColor="warning">{{'agentBuilder.dictionary.noSynonym'|translateTA}}</nz-tag>
                        }
                    </li>
                }
            </ul>
        }

        @if (termosJaExistentes.length > 0) {
            <h4 class="dictionary-import-title">
                {{'agentBuilder.dictionary.importWillSkip'|translateTA}} ({{termosJaExistentes.length}})
            </h4>
            <ul class="dictionary-import-list dictionary-import-skipped">
                @for (termo of termosJaExistentes; track termo.termoCanonico) {
                    <li>{{termo.termoCanonico}}</li>
                }
            </ul>
        }

    </ng-container>
</nz-modal>
